import React from 'react';

import { homecleanState } from 'atoms';
import { useRecoilState } from 'recoil';

import Homeclean from '@components/homeclean';
import Internet from '@components/internet';

import { sendAmplitudeEvent } from '@utils/analytics';
import { AMPLITUDE_EVENT, PAGE_URL } from '@utils/constants';

type BannerIframeContentsProps = {
  isInternet: boolean;
  isInterentZapier: boolean;
};
const BannerIframeContents: React.FC<BannerIframeContentsProps> = ({ isInternet, isInterentZapier }) => {
  const [homecleanIframe, setHomecleanIframe] = useRecoilState(homecleanState);

  const handleClick = () => {
    setHomecleanIframe((prevState) => ({
      ...prevState,
      isHomecleanIframeExpanded: !prevState.isHomecleanIframeExpanded,
    }));
    sendAmplitudeEvent(AMPLITUDE_EVENT.CONTINUE_FLOW, {
      location: window.location.pathname,
      origin: window.location.origin,
    });
  };

  return (
    <>
      {homecleanIframe.isHomeclean ? <Homeclean handleClick={handleClick} pageUrl={PAGE_URL.HOMECLEAN} /> : null}
      {isInternet ? <Internet pageUrl={`${PAGE_URL.INTERNET}`} /> : null}
      {isInterentZapier ? <Internet pageUrl={`${PAGE_URL.INTERNET_ZAPIER}`} /> : null}
    </>
  );
};

export default BannerIframeContents;
